"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRemoteQueryInvoker = void 0;
const RemoteQueryInvoker_1 = require("./RemoteQueryInvoker");
const RpcRequestBuilder_1 = require("../RpcRequestBuilder");
const RpcRequest_1 = require("../RpcRequest");
const cq_core_1 = require("@leavy/cq-core");
/**
 * RPC Query Invoker using HTTP as transport
 */
class HttpRemoteQueryInvoker extends RemoteQueryInvoker_1.RemoteQueryInvoker {
    constructor(configProvider, axiosHttp, ambientValueInjector = new cq_core_1.DefaultAmbientValueInjector()) {
        super(RpcRequest_1.RequestProtocol.Http, new RpcRequestBuilder_1.RpcRequestBuilder([configProvider], axiosHttp), ambientValueInjector);
    }
}
exports.HttpRemoteQueryInvoker = HttpRemoteQueryInvoker;
//# sourceMappingURL=HttpRemoteQueryInvoker.js.map